import React, { useState, useCallback, useMemo, ReactNode } from 'react';
import {
  NotificationContext,
  NotificationSeverity,
  NotificationState,
} from './notificationContextDef';

interface NotificationProviderProps {
  children: ReactNode;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  const [notification, setNotification] = useState<NotificationState>({
    message: null,
    severity: 'info',
    open: false,
  });

  const showNotification = useCallback(
    (message: string, severity: NotificationSeverity = 'info', duration: number = 15000) => {
      setNotification({
        message,
        severity,
        open: true,
        autoHideDuration: duration,
      });
    },
    [],
  );

  const hideNotification = useCallback(() => {
    setNotification((prev) => ({ ...prev, open: false }));
  }, []);

  const value = useMemo(
    () => ({
      showNotification,
      hideNotification,
      notification,
    }),
    [showNotification, hideNotification, notification],
  );

  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>;
};
